
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ef32u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $iLgzu = parcelRequire("iLgzu");


var $3QLqz = parcelRequire("3QLqz");


var $jMyy4 = parcelRequire("jMyy4");

const $1546310cc6a3e3ac$export$b04f2418ece85f67 = ()=>{
    const $ = (0, $frIzR.c)(11);
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== currentSpaceKey) {
        t0 = {
            variables: {
                promotedSpaceKey: currentSpaceKey,
                promotedSpacesLimit: 1,
                otherSpacesLimit: 1
            }
        };
        $[0] = currentSpaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const { data: promotedSpaceData, error: promotedSpaceError } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t0);
    const spaceKey = promotedSpaceData?.experimentalPromotedSpaces?.nodes?.[0]?.id || "";
    let t1;
    if ($[2] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[2] = spaceKey;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = !spaceKey;
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { error: operationsError } = (0, $jMyy4.useQueryInterop)((0, $3QLqz.default), t3);
    let t4;
    let t5;
    if ($[7] !== operationsError || $[8] !== promotedSpaceError) {
        t4 = ()=>{
            (0, $7Sm4c.markErrorAsHandled)(promotedSpaceError);
            (0, $7Sm4c.markErrorAsHandled)(operationsError);
        };
        t5 = [
            promotedSpaceError,
            operationsError
        ];
        $[7] = operationsError;
        $[8] = promotedSpaceError;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $42omo.useEffect)(t4, t5);
    return null;
};
module.exports["CreateContentDataPreloader"] = $1546310cc6a3e3ac$export$b04f2418ece85f67;

});


//# sourceMappingURL=CreateContentDataPreloader.b472514c.js.map
